import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import DoneIcon from '@mui/icons-material/Done';
import {
  Button,
  Edit,
  NavigationArrow,
  PageTitleAndSubTitle,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React, { useEffect, useState } from 'react';
import componentConstants from '../../core-utils/messages/componentConstants';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  Avatar,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { useStores } from '../../stores';
import { observer } from 'mobx-react';
import { useNavigate, useLocation } from 'react-router-dom';
import CareNavigatorProfileCard from '../../_components/organisms/CareNavigatorProfileCard';
import {
  formatCareNavigatorCardData,
  formatCareNavigatorProfileDetails,
} from '../../core-utils/helper-utils/careNavigatorHelper';
import properties from '../../core-utils/properties';
import axios from 'axios';
import Loader from '../../_components/molecules/Loader';
import useSnackbar from '../../core-utils/custom-hooks/Snackbar';
import Snackbar from '../../_components/atoms/Snackbar';

type LocationState = {
  previousRoute: string;
};
export interface ProfilePageProps {}

const ProfilePage: React.FC<ProfilePageProps> = observer(({}) => {
  const useStyles = makeStyles()(() => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 66px 63px',
      width: '1372px',
    },
    separator: {
      width: '100%',
      height: '1px',
      backgroundColor: patientAccessTheme.palette.grey[300],
      border: 'none',
    },
    profileImage: {
      flex: 2,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      overflow: 'hidden',
    },

    upperProfile: {
      width: '100%',
      height: '100px',
      background: 'linear-gradient(46.53deg, #C4CEF9 0%, #7D81C3 139.36%)',
      borderRadius: '0 0 50px 50px',
    },
    border: {
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      borderRadius: '0.5rem',
      minHeight: '370px',
    },
    subText: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '24px',
      color: patientAccessTheme.palette.text.mediumemphasis,
      marginTop: '0.5rem',
    },
    details: {
      padding: '1rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
    },
    infoContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      backgroundColor: patientAccessTheme.palette.grey[300],
      borderRadius: '0.25rem',
      padding: '0.5rem',
    },
    editIcon: {
      height: '22px',
      width: '22px',
      '& path': {
        fill: patientAccessTheme.palette.primary.main,
      },
    },
    inputFields: {
      marginTop: '100px',
      display: 'flex',
      gap: '20px',
      flexDirection: 'row',
    },
    cancelButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border: '1px solid ' + patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
    saveButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border: '1px solid ' + patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
    platformHeader: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '4px 8px',
      backgroundColor: patientAccessTheme.palette.grey[700],
    },
    platformName: {
      display: 'flex',
      flexDirection: 'row',
      gap: '4px',
      color: patientAccessTheme.palette.status.white,
    },
    quotaButton: {
      padding: '9px 16px',
      margin: '4px',
      width: '180px',
      height: '26px',
      backgroundColor: patientAccessTheme.palette.status.white,
      text: patientAccessTheme.palette.text.highemphasis,
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '14px',
      lineHeight: '21px',
      fontWeight: 500,
    },
    buttons: {
      display: 'flex',
      flexDirection: 'row',
      margin: '20px 0px',
      justifyContent: 'center',
      gap: '20px',
    },
    editButton: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '10px',
    },
  }));

  const [careNavigatorDetails, setcareNavigatorDetails] = useState<any>({});
  const [userData, setUserData] = useState<any>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [superAdmin, setSuperAdmin] = useState<boolean>(false);
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const { classes } = useStyles();
  const messages = componentConstants.PAGES.PROFILE_PAGE;
  const loginPageStore = useStores().loginPageStore;
  const userDetailsStore = useStores().userDetailsStore;
  const isCareNavigator = loginPageStore.isCareNavigator;
  const navigate = useNavigate();
  const location = useLocation().state as LocationState;
  const [loading, setLoading] = useState<boolean>(false);
  const { snackbarState, handleCloseSnackBar, openSnackbar } = useSnackbar();

  const InfoContainer = ({
    label,
    value,
  }: {
    label: string;
    value: string;
  }) => {
    return (
      <div className={classes.infoContainer}>
        <Typography fontType="semiBold" margin="0" className={classes.subText}>
          {label}
        </Typography>
        <Typography className={classes.subText} margin="0">
          {value}
        </Typography>
      </div>
    );
  };

  const extractUserData = () => {
    setLoading(true);
    const {
      firstName,
      lastName,
      email,
      userResponse: {
        role,
        totalGroups,
        employerGroups,
        riskManagement,
        riskManagementQuota,
        riskManagementScreens,
        complianceAssuranceScreens,
        complianceAssurance,
        complianceAssuranceQuota,
        careNavigationScreens,
        careNavigation,
        careNavigationQuota,
      },
    } = loginPageStore;

    let roleName: string = '';

    switch (role.name) {
      case 'admin':
        roleName = messages.ADMIN;
        break;
      case 'super_admin':
        setSuperAdmin(true);
        roleName = messages.SUPER_ADMIN;
        break;
      default:
        roleName = messages.USER;
        break;
    }

    setLoading(false);
    setFirstName(firstName);
    setLastName(lastName);
    const groups: string[] = [];
    if (employerGroups) {
      employerGroups.map((group) => {
        groups.push(group.employerName);
      });
    }

    return {
      name: `${firstName} ${lastName}`,
      email: email,
      role: roleName,
      totalGroups,
      groups,
      riskManagement,
      riskManagementQuota,
      riskManagementScreens,
      complianceAssuranceScreens,
      complianceAssurance,
      complianceAssuranceQuota,
      careNavigationScreens,
      careNavigation,
      careNavigationQuota,
    };
  };

  const getCareNavigatorDetails = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.careNavigatorBaseURL +
      properties.getCareNavigatorProfile;

    const requestData = {
      cn_id: loginPageStore.userId,
    };
    return await axios.post(url, requestData);
  };

  const updateUser = async () => {
    await axios
      .patch(
        properties.userManagementBaseUrl +
          properties.users +
          '/' +
          loginPageStore.userId,
        {
          firstName: firstName,
          lastName: lastName,
          riskManagement: userDetailsStore.riskManagement,
          complianceAssurance: userDetailsStore.complianceAssurance,
          careNavigation: userDetailsStore.careNavigation,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          setUserData((prev: any) => ({
            ...prev,
            name: `${firstName} ${lastName}`,
          }));
          loginPageStore.addUserName(firstName, lastName);
          setIsEdit(false);
        }
      })
      .catch((error) =>
        openSnackbar(error.response?.data?.error, 'error', 6000),
      );
  };

  const apiCalls = async () => {
    setLoading(true);
    await Promise.allSettled([getCareNavigatorDetails()]).then((responses) => {
      setLoading(false);
      if (responses[0].status === 'rejected') {
        openSnackbar('Care Navigator Fetch Error', 'error', 5000);
      }
      if (responses[0].status === 'fulfilled') {
        setcareNavigatorDetails(responses[0].value.data?.data);
      }
    });
    setLoading(false);
  };

  useEffect(() => {
    isCareNavigator ? apiCalls() : setUserData(extractUserData());
  }, []);

  return (
    <div className={classes.root}>
      <PageTitleAndSubTitle
        title={
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
            <NavigationArrow
              style={{ rotate: '180deg', cursor: 'pointer' }}
              onClick={() => navigate(location?.previousRoute)}
            />
            <Typography
              fontSize="18px"
              fontType="semiBold"
              lineHeight="24px"
              align="center"
              textColor={patientAccessTheme.palette.text.highemphasis}
            >
              {messages.TITLE}
            </Typography>
          </div>
        }
        subTitle={messages.SUBTITLE}
      />
      <hr className={classes.separator} />
      {loading ? (
        <Loader />
      ) : isCareNavigator ? (
        <CareNavigatorProfileCard
          {...formatCareNavigatorCardData(careNavigatorDetails)}
          details={formatCareNavigatorProfileDetails(careNavigatorDetails)}
        />
      ) : (
        <Grid
          container
          style={{
            gap: '1rem',
            marginTop: '1rem',
          }}
        >
          <Grid className={`${classes.border} ${classes.profileImage}`}>
            <div className={classes.upperProfile}></div>
            <div
              style={{
                position: 'absolute',
                top: '40px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Avatar
                avatarText={
                  <Typography
                    textColor={patientAccessTheme.palette.primary.main}
                    fontType="medium"
                    fontSize="70px"
                  >
                    {userData?.name?.charAt(0).toUpperCase()}
                  </Typography>
                }
                width="128px"
                height="128px"
                backgroundColor={patientAccessTheme.palette.grey[300]}
                alt={''}
                style={{ margin: '0px 10px 0px 0px' }}
              />
            </div>
            {isEdit ? (
              <Grid>
                <Grid className={classes.inputFields}>
                  <TextField
                    value={firstName}
                    height="36px"
                    width="201px"
                    inputPropsStyle={{
                      padding: '16px',
                    }}
                    onChange={(e: any) => setFirstName(e.target.value)}
                  />
                  <TextField
                    value={lastName}
                    height="36px"
                    width="201px"
                    inputPropsStyle={{
                      padding: '16px',
                    }}
                    onChange={(e: any) => setLastName(e.target.value)}
                  />
                </Grid>
                <Grid className={classes.buttons}>
                  <Grid>
                    <Button
                      label={messages.CANCEL}
                      variant="outlined"
                      className={classes.cancelButton}
                      onClick={() => setIsEdit(false)}
                    />
                  </Grid>
                  <Grid>
                    <Button
                      label={messages.SUBMIT}
                      variant="contained"
                      className={classes.saveButton}
                      disabled={false}
                      onClick={updateUser}
                    />
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <>
                <Typography
                  fontSize="18px"
                  fontType="semiBold"
                  lineHeight="24px"
                  align="center"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                  margin="6rem 0 0 0"
                >
                  {userData?.name}
                </Typography>
                <Typography className={classes.subText}>
                  {userData?.role}
                </Typography>
                <Typography className={classes.subText}>
                  {userData?.email}
                </Typography>
                <Grid
                  onClick={() => setIsEdit(true)}
                  className={classes.editButton}
                >
                  <Edit className={classes.editIcon} />
                  <Typography
                    fontSize="18px"
                    fontType="semiBold"
                    lineHeight="24px"
                    textColor={patientAccessTheme.palette.primary.main}
                    margin="0 0 0 5px"
                  >
                    Edit
                  </Typography>
                </Grid>
              </>
            )}
            <div
              style={{
                height: '20px',
                backgroundColor: 'red',
                width: '100%',
                marginTop: 'auto',
                background:
                  'linear-gradient(46.53deg, #C4CEF9 0%, #7D81C3 139.36%)',
                borderRadius: '50px 50px 8px 8px',
              }}
            ></div>
          </Grid>
          <Grid
            className={`${classes.border} ${classes.details}`}
            style={{ flex: 3 }}
          >
            <div
              style={{
                display: 'flex',
                gap: '1rem',
                width: '100%',
              }}
            >
              <InfoContainer label="Role" value={userData?.role} />
              <InfoContainer label="Email" value={userData?.email} />
              {!superAdmin && (
                <InfoContainer
                  label="No. of Groups"
                  value={userData?.totalGroups || '-'}
                />
              )}
            </div>
            {!superAdmin && (
              <>
                <InfoContainer
                  label="Groups"
                  value={userData?.groups?.join(' | ')}
                />
                <div
                  style={{
                    height: '2px',
                    backgroundColor: patientAccessTheme.palette.grey[300],
                    width: '100%',
                    margin: '4px 2px',
                  }}
                ></div>
                <Grid>
                  {userData.riskManagement && (
                    <>
                      <Grid className={classes.platformHeader}>
                        <Grid className={classes.platformName}>
                          <Typography
                            fontSize="14px"
                            fontType="normal"
                            lineHeight="22px"
                            textColor={patientAccessTheme.palette.status.white}
                          >
                            {messages.riskManagement}
                          </Typography>
                          <DoneIcon
                            htmlColor={patientAccessTheme.palette.status.white}
                          />
                        </Grid>
                        <Button
                          label={
                            messages.memberLives +
                            ' : ' +
                            userData.riskManagementQuota
                          }
                          variant="contained"
                          className={classes.quotaButton}
                          disabled={true}
                          width="180px"
                          height="28px"
                          textColor={
                            patientAccessTheme.palette.text.highemphasis
                          }
                          styleProps={{
                            backgroundColor:
                              patientAccessTheme.palette.grey[100],
                            color: patientAccessTheme.palette.text.highemphasis,
                            fontWeight: 500,
                          }}
                        />
                      </Grid>
                      <InfoContainer
                        label=""
                        value={userData?.riskManagementScreens?.join(' | ')}
                      />
                    </>
                  )}
                  {userData.complianceAssurance && (
                    <>
                      <Grid className={classes.platformHeader}>
                        <Grid className={classes.platformName}>
                          <Typography
                            fontSize="14px"
                            fontType="normal"
                            lineHeight="22px"
                            textColor={patientAccessTheme.palette.status.white}
                          >
                            {messages.complianceAssurance}
                          </Typography>
                          <DoneIcon
                            htmlColor={patientAccessTheme.palette.status.white}
                          />
                        </Grid>
                        <Button
                          label={
                            messages.docUnits +
                            ' : ' +
                            userData.complianceAssuranceQuota
                          }
                          variant="contained"
                          className={classes.quotaButton}
                          disabled={true}
                          width="180px"
                          height="28px"
                          textColor={
                            patientAccessTheme.palette.text.highemphasis
                          }
                          styleProps={{
                            backgroundColor:
                              patientAccessTheme.palette.grey[100],
                            color: patientAccessTheme.palette.text.highemphasis,
                            fontWeight: 500,
                          }}
                        />
                      </Grid>
                      <InfoContainer
                        label=""
                        value={userData?.complianceAssuranceScreens?.join(
                          ' | ',
                        )}
                      />
                    </>
                  )}
                  {userData.careNavigation && (
                    <>
                      <Grid className={classes.platformHeader}>
                        <Grid className={classes.platformName}>
                          <Typography
                            fontSize="14px"
                            fontType="normal"
                            lineHeight="22px"
                            textColor={patientAccessTheme.palette.status.white}
                          >
                            {messages.careNavigation}
                          </Typography>
                          <DoneIcon
                            htmlColor={patientAccessTheme.palette.status.white}
                          />
                        </Grid>
                        <Button
                          label={
                            messages.cases +
                            ' : ' +
                            userData.careNavigationQuota
                          }
                          variant="contained"
                          className={classes.quotaButton}
                          disabled={true}
                          width="180px"
                          height="28px"
                          textColor={
                            patientAccessTheme.palette.text.highemphasis
                          }
                          styleProps={{
                            backgroundColor:
                              patientAccessTheme.palette.grey[100],
                            color: patientAccessTheme.palette.text.highemphasis,
                            fontWeight: 500,
                          }}
                        />
                      </Grid>
                      <InfoContainer
                        label=""
                        value={userData?.careNavigationScreens?.join(' | ')}
                      />
                    </>
                  )}
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </div>
  );
});

export default ProfilePage;
